import styled, { css } from 'styled-components';

import { Text, Banner } from '@gympass/yoga';
import { wellzTheme } from '@wellz-theme/mui';

export const CPDashboardContainer = styled.main`
  min-height: 100vh;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
`;

export const Section = styled.section`
  overflow-y: auto;
  height: calc(100vh - 208px);
  background-color: white;
`;

export const NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: ${({ theme }) => theme.yoga.spacing.huge}px;

  svg {
    width: ${wellzTheme.spacing(25)};
    height: ${wellzTheme.spacing(25)};
  }
`;

export const NoResultText = styled(Text.Small)`
  font-style: normal;
  text-align: left;
  max-width: 303.64px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.xlarge}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  line-height: ${({ theme }) => theme.yoga.lineHeights.xlarge}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  color: ${({ theme }) => theme.yoga.colors.text.primary};
`;

export const WillUnlinkBanner = styled(Banner)`
  ${({ theme }) => css`
    margin: ${theme.yoga.spacing.zero};
    border-radius: ${theme.yoga.radii.sharp};

    button {
      color: ${theme.yoga.colors.stamina};

      &:not([disabled]):hover {
        color: ${theme.yoga.colors.deep};
      }
    }

    svg {
      fill: ${theme.yoga.colors.stamina};
    }
  `}
`;
